<template>
    <div class="identification-container">
        <div class="bg">
            <img src="https://www.freeiconspng.com/uploads/clipart--person-icon--cliparts-15.png">
            <h2>{{ getString('identificacao') }}</h2>
            <template v-if="!requestPin">
                <span v-if="this.cashBackCampaign && this.cashBackCampaign.campaignEnabled !== 'none'">
                    {{ getString('fidelidade_message') }}
                </span>
                <span v-else> {{ getString('informe_celular') }} </span>
                <span class="fidelity-lpgd">{{ getString('fidelity_lpgd') }}</span>
                <div class="input-container" :class="hasError ? 'error-shake' : ''">
                    <div id="phone-number" class="div-input-android" :class="{ 'error-signal': hasError }"></div>
                    <span v-if="this.message" class="message"> {{ this.message }}</span>
                </div>
            </template>
            <template v-else>
                <span> {{ getString('informe_pin') }} </span>
                <div class="input-container" :class="hasError ? 'error-shake' : ''">
                    <div id="pin-number" class="div-input-android" :class="{ 'error-signal': hasError }"></div>
                    <span v-if="this.message" class="message"> {{ this.message }}</span>
                </div>
            </template>
            <div class="buttons-container">
                <DefaultButton v-for="(btn, key) in getButtons()" :key="key" :disabled="!controlsEnabled" :text="btn.text" @defaultBtnClick="btn.action()"
                    class="buttons">
                </DefaultButton>
            </div>

            <AndroidKeyboard id="android-keyboard" :inputElement="inputElement" :layout="layout" :bigNumeric="true" :roundNumeric="isGomLayout"
                :onInput="applyPhoneMask" :maxCaracteres="15">
            </AndroidKeyboard>
        </div>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton.vue'
import LocaleController from '@/assets/controllers/LocaleController'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import ClarityController from '../assets/controllers/ClarityController'

export default {
    name: 'IdentificationModal',
    components: {
        DefaultButton,
        AndroidKeyboard
        // 'vue-touch-keyboard': VueTouchKeyboard.component
    },
    pros: ['show', 'validTemporaryCode'],
    data () {
        return {
            inputElement: null,
            visible: false,
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            input: null,
            phoneMask: '(##) #####-####',
            phoneNumber: '',
            buttons: [
                {
                    text: this.getString('nao_q_informar'),
                    action: this.continue,
                    visible: true
                },
                {
                    text: this.getString('reenviar'),
                    action: this.resendPin,
                    visible: false
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm,
                    visible: true
                }
            ],
            hasError: false,
            requestPin: false,
            consumerData: null,
            pin: '',
            cashBackCampaign: null,
            controlsEnabled: true,
            message: '',
            isGomLayout: Util.getLocalConfigs('utiliza_layout_gom') || false
        }
    },
    mounted () {
        this.inputElement = document.getElementById('phone-number')
        CashbackCampaingController.clearPhone()
        this.checkCampaign()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        checkCampaign: async function () {
            this.cashBackCampaign = await CashbackCampaingController.getStatus()
        },
        getButtons: function () {
            return this.buttons.filter(e => e.visible)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        confirm: async function () {
            if (this.requestPin) {
                await this.validatePin()
                return
            }
            this.hasError = false
            this.phoneNumber = document.getElementById('phone-number').innerText

            if (this.validPhoneNumber()) {
                this.sanitizePhoneNumber()
                await this.checkRequestPin()
                CashbackCampaingController.setPhone(this.phoneNumber)
                ClarityController.event('informou_telefone_para_fidelidade')
                if (this.cashBackCampaign && this.cashBackCampaign.campaignEnabled === 4) {
                    await CashbackCampaingController.getClientInfo(this.phoneNumber)
                }
                if (!this.requestPin) { this.continue() }
            } else {
                this.hasError = true
                let sf = this
                setTimeout(() => {
                    sf.hasError = false
                }, 1000)
            }
        },
        continue: async function () {
            this.$emit('navigateToHome')
            this.$emit('close')
        },
        validPhoneNumber: function () {
            let regex = null
            let ddi = '+55' // this.phoneNumber.substring(0, 3)
            let phoneNumber = this.phoneNumber.replace(/[^\d]+/g, '')
            if (ddi === '+55') {
                regex = new RegExp('^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$')
                return regex.test(phoneNumber)
            } else {
                regex = new RegExp(/^(\d)\1+$/)
                return !regex.test(phoneNumber) && (phoneNumber.length > 6)
            }
        },
        sanitizePhoneNumber: function () {
            let phoneNumber = this.phoneNumber.replace(/[^\d]+/g, '')
            this.phoneNumber = phoneNumber
        },
        applyPhoneMask: function (input) {
            if (!this.requestPin) {
                if (!input) return ''
                input = input.replace(/\D/g, '')
                input = input.replace(/(\d{2})(\d)/, '($1) $2')
                input = input.replace(/(\d)(\d{4})$/, '$1-$2')
                return input
            } else {
                if (!input) return ''
                input = input.replace(/\D/g, '')
                return input
            }
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        checkRequestPin: async function () {
            let result = null
            this.controlsEnabled = false
            if (!this.cashBackCampaign || this.cashBackCampaign.campaignEnabled !== 1) {
                this.controlsEnabled = true
                return false
            }
            result = await CashbackCampaingController.getPinValidationStatus(this.phoneNumber)
            if (result && result.solicita_pin && result.solicita_pin._text === 'true') {
                this.consumerData = result
                this.inputElement.innerText = ''
                setTimeout(() => {
                    this.inputElement = document.getElementById('pin-number')
                }, 50)
                this.buttons[0].visible = true
                this.buttons[1].visible = true
                this.requestPin = true
                this.controlsEnabled = true
                this.$forceUpdate()
            }
        },
        validatePin: async function () {
            this.controlsEnabled = false
            this.pin = this.inputElement.innerText

            if (!this.pin) {
                this.controlsEnabled = true
                this.hasError = true
                let sf = this
                setTimeout(() => {
                    sf.hasError = false
                }, 1000)
                return false
            }

            const params = {
                consumerId: this.consumerData.customer_id._text,
                storeCode: this.consumerData.loja_id._text,
                pin: this.pin,
                phone: this.phoneNumber
            }

            const result = await CashbackCampaingController.validatePin(params)

            if (!result || !result.valid_pin) {
                this.controlsEnabled = true
                return false
            }
            if (result.valid_pin._text === 'false') {
                // Pin incorreto
                this.hasError = true
                let sf = this
                setTimeout(() => {
                    sf.hasError = false
                    sf.inputElement.innerText = ''
                    sf.controlsEnabled = true
                }, 1000)
            }
            if (result.valid_pin._text === 'true') {
                this.controlsEnabled = true
                this.$emit('navigateToHome')
            }
        },
        resendPin: async function () {
            this.controlsEnabled = false
            this.inputElement = ''
            const params = {
                consumerId: this.consumerData.customer_id._text,
                storeCode: this.consumerData.loja_id._text,
                phone: this.phoneNumber
            }

            const result = await CashbackCampaingController.resendPin(params)
            if (result && result.sms) {
                this.consumerData = result
                this.message = this.getString('Pin reenviado')
            } else {
                this.message = this.getString('falha ao reenviar o pin')
            }
            this.controlsEnabled = true
            this.clearMessage()
        },
        clearMessage: function () {
            setTimeout(() => {
                this.message = ''
            }, 2000)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.identification-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    padding: 20px;
    box-sizing: border-box;

    .bg {
        position: relative;
        background: @white;
        padding: 30px;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        max-width: calc(100vw - 300px);
        width: 100%;
        max-height: calc(100vh - 40px);
        overflow-y: auto;
        opacity: 1;
        #android-keyboard {
            margin: 15px;
        }
        img {
            display: block;
            margin: auto;
            width: 100px;
            height: 100px;
            border: solid 1px;
            border-radius: 100%;
            object-fit: contain;
            padding: 10px;
        }

        h2,
        span,
        img {
            display: block;
            font-size: 2rem;
            margin: auto;
            text-align: center;
            opacity: 1;
        }
        span {
            // line-height: 50px;
            margin: 0 15px;
        }
        h2,
        span.qst {
            margin: 15px 0;
            font-weight: bold;
        }

        .input-container {
            margin: 40px 15px;
            text-align: center;

            .div-input-android {
                position: relative;
                margin: 50px 15px;
                display: block;
                font-size: 4rem;
                height: 85px;
                background-color: white;
                color: black;
                border: 2px solid black;
                border-radius: 20px;
                padding: 0 20px;

                &.error-shake {
                    input {
                        background-color: rgba(250, 9, 9, 0.397);
                    }

                    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                    transform: translate3d(0, 0, 0);
                }
            }
            .message {
                font-size: 25px;
            }

            .error-signal {
                border: 4px solid red;
                animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
                transform: translate3d(0, 0, 0);
            }
        }
        .fidelity-lpgd {
            font-size: 23px;
            color: #666;
            margin-top: 15px;
            text-align: center;
        }

        .buttons-container {
            margin: 15px 15px 48px 15px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: center;
            justify-content: space-around;
            align-items: center;

            button:not(:last-of-type) {
                background: white;
                border: solid 1px rgba(3, 0, 79, 0.4);
                color: black;
            }

            button {
                width: 46%;
            }
        }
    }

    #keyboard {
        .keyboard;
        width: inherit;
        max-width: 930px;
        top: inherit;
        position: unset;
        bottom: 0;
    }

    @keyframes shake {

        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .identification-container {
        padding: 40px;

        .bg {
            max-width: 400px;
            padding: 20px;
            border-radius: 10px;

            img {
                width: 40px;
                height: 40px;
            }

            img {
                font-size: 20px;
            }

            h2 {
                font-size: 21px;
                margin: 10px 0;
            }

            span {
                font-size: 16px;
            }
            .fidelity-lpgd {
                font-size: 13px;
                margin-top: 7px;
            }

            .input-container {
                margin: 20px 0;

                .div-input-android {
                    margin: 0 20px;
                    font-size: 22px;
                    height: 35px;
                    padding: 5px 10px 0 10px;
                    width: auto;
                }
            }

            .buttons-container {
                margin: 10px 0;
                .buttons {
                    max-width: 150px;
                }
            }
        }
    }
}

@media (min-width: 901px) and (max-width: 1025px) {

    //@tablet
    .identification-container {
        padding: 30px;
        .bg {
            #android-keyboard {
                margin: 5px;
            }
            span {
                font-size: 30px;
            }
            .input-container {
                margin: 30px 15px;

                .div-input-android {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 60px;
                    margin: 30px 0;
                    font-size: 40px;
                }
            }
            .fidelity-lpgd {
                font-size: 18px;
                margin-top: 10px;
            }
            .buttons-container {
                margin: 10px 0;
                .buttons {
                    // max-width: 220px;
                    width: 45%;
                    min-width: 220px;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 900px) {
//@mehloretec
    .identification-container {
        padding: 25px;
        .bg {
            max-width: calc(100vw - 190px);
            #android-keyboard {
                margin: 5px;
            }
            span {
                font-size: 25px;
            }
            .input-container {
                margin: 25px 15px;

                .div-input-android {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 60px;
                    margin: 25px 0;
                    font-size: 30px;
                }
            }
            .fidelity-lpgd {
                font-size: 18px;
                margin-top: 10px;
            }
            .buttons-container {
                margin: 10px 0;
                .buttons {
                    // max-width: 220px;
                    width: 45%;
                    min-width: 220px;
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .identification-container {
        padding: 10px;

        .bg {
            padding: 30px 0px 30px 20px;
            display: grid;
            height: auto;
            width: auto;
            min-width: 400px;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto auto auto auto 1fr;
            grid-template-areas:
                "header keyboard"
                "title keyboard"
                "msg keyboard"
                "content keyboard"
                "buttons keyboard"
                "lpgd keyboard";
            column-gap: 15px;
            align-items: center;

            img {
                width: 50px;
                height: 50px;
                grid-area: header;
            }

            h2 {
                font-size: 22px;
                margin: 10px 0;
                grid-area: title;
                align-self: center;
            }

            span:not(.fidelity-lpgd):not(.message) {
                font-size: 18px;
                grid-area: content;
                margin: 10px 0;
                grid-area: msg;
            }

            .fidelity-lpgd {
                font-size: 16px;
                grid-area: lpgd;
                margin-top: 20px;
                align-self: end;
            }

            .input-container {
                margin: 0 0;
                grid-area: content;
                .div-input-android {
                    margin: 15px 0;
                    font-size: 30px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: auto;
                    border-radius: 25px;
                    border: 2px solid rgba(3, 0, 79, 0.15);
                }
                .message {
                    font-size: 16px;
                }
            }

            .buttons-container {
                margin: 10px 0;
                grid-area: buttons;
                width: 100%;
                display: flex;
                flex-direction: row;
                align-self: start;
                flex-wrap: nowrap;
                justify-content: space-between;
            }

            #android-keyboard {
                grid-area: keyboard;
                margin: 0;
                align-self: center;
            }
        }
    }
}

@media (orientation: landscape) and (max-width: 1025px) {
    .identification-container {
        .bg {
            max-width: calc(100vw - 100px);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/IdentificationModal.vue